import { defaultHttpClient } from '../../httpClient';
import type { PostReviewLikeResponse } from './types';

/**
 * - 리뷰 좋아요 API
 */
export const postReviewLike = (reviewSno: number) => {
  return defaultHttpClient
    .request<PostReviewLikeResponse>({
      method: 'POST',
      url: `/api/v2/reviews/${reviewSno}/like/`,
    })
    .then(result => result.data);
};
